import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { bool, func, string } from "prop-types";
import CustomButton from "../CustomButton";

const TestFeatureUnavailableModal = ({ open, onClose, featureName }) => (
  <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby="test-feature-unavailable-title"
    PaperProps={{
      style: {
        width: "28rem",
        maxWidth: "95vw",
        borderRadius: "1rem",
        padding: "0.5rem",
      },
    }}
  >
    <div className="d-flex justify-content-between align-items-center">
      <DialogTitle id="test-feature-unavailable-title" style={{ paddingBottom: 0 }}>
        Not available on test
      </DialogTitle>
      <IconButton onClick={onClose} aria-label="Close">
        <CloseIcon />
      </IconButton>
    </div>
    <DialogContent>
      <p style={{ margin: 0, lineHeight: 1.5 }}>
        <strong>{featureName}</strong> is disabled on the test environment. Use
        production to try this feature.
      </p>
    </DialogContent>
    <DialogActions>
      <span className="w-50">
        <CustomButton
          handleClick={onClose}
          text="OK"
          backgroundColor="#1d4ed8"
          color="#fff"
        />
      </span>
    </DialogActions>
  </Dialog>
);

TestFeatureUnavailableModal.propTypes = {
  open: bool.isRequired,
  onClose: func.isRequired,
  featureName: string,
};

TestFeatureUnavailableModal.defaultProps = {
  featureName: "This feature",
};

export default TestFeatureUnavailableModal;
